import { useEffect, useRef } from "react";

// Adds 'is-visible' class when element scrolls into view
export default function useReveal(options = {}) {
  const ref = useRef(null);
  const { root = null, rootMargin = "0px", threshold = 0.12 } = options;
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { root, rootMargin, threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [root, rootMargin, threshold]);
  return ref;
}
